<template>
  <div class="main">
    <div class="login-header"></div>
    <div class="login-container">
      <img src="./../assets/logo-login.png" alt="logo safe" />
      <div class="login-form">
        <h1>Password reset</h1>
        <form @submit.prevent="onSubmit">   
            <div class="row">
            <!-- Password -->
              <div class="form-group" :class="{ error: v$.form.password.$errors.length }">
                  <input class="form-control" placeholder="Password*" type="password" v-model="v$.form.password.$model">
                  <!-- error message -->
                  <template v-if="v$.form.password.$errors.length > 0">                
                      <div class="error-msg" v-if="v$.form.password.$errors[0].$validator == 'required'">This field is required.</div>
                      <div class="error-msg" v-if="v$.form.password.$errors[0].$validator == 'min'">{{v$.form.password.$errors[0].$params.min}} caracters minimum allowed.</div>
                      <div class="error-msg" v-if="v$.form.password.$errors[0].$validator == 'max'">{{v$.form.password.$errors[0].$params.max}} caracters maximum allowed.</div>
                  </template>
              </div>
          </div>
         <div class="row">
            <!-- Password -->
              <div class="form-group" :class="{ error: v$.form.passwordConfirm.$errors.length }">
                  <input class="form-control" placeholder="Password confirm*" type="password" v-model="v$.form.passwordConfirm.$model">
                  <!-- error message -->
                  <template v-if="v$.form.passwordConfirm.$errors.length > 0">                
                      <div class="error-msg" v-if="v$.form.passwordConfirm.$errors[0].$validator == 'required'">This field is required.</div>
                      <div class="error-msg" v-if="v$.form.passwordConfirm.$errors[0].$validator == 'sameAs'">The two passwords are not identical.</div>
                      <div class="error-msg" v-if="v$.form.passwordConfirm.$errors[0].$validator == 'min'">{{v$.form.passwordConfirm.$errors[0].$params.min}} caracters minimum allowed.</div>
                      <div class="error-msg" v-if="v$.form.passwordConfirm.$errors[0].$validator == 'max'">{{v$.form.passwordConfirm.$errors[0].$params.max}} caracters maximum allowed.</div>
                  </template>
              </div>
          </div>
          <!-- Submit Button -->
          <div class="row-btn">
              <input type="submit" :disabled="v$.form.$invalid" class="btn" value="reset" />
          </div>
          <!-- Errors -->
        </form>
         <div class="notices success" v-if="success">{{ success}}</div>
        <div class="notices errors" v-if="errors">An error has occured : <br />{{ errors}}</div>
        <router-link :to="{name : 'Home'}" class="back">{{ success ? 'Sign in' : 'Back' }}</router-link>
      </div>
    </div>

  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, maxLength, minLength, sameAs } from '@vuelidate/validators';
import axios from 'axios';

export default {
  name: 'PasswordReset',
    data() {
        return {
            form : {
                passwordConfirm : "",
                password : "",
            },
            success : false,
            errors : null,
        }
    },
    setup () {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            form : {   
                passwordConfirm: {
                    required, max : maxLength(50), min : minLength(8), sameAs : sameAs(this.form.password)
                },
                password : {
                  required, max : maxLength(50), min : minLength(8)
                }
                
            }
        }        
    },
    methods: {
        async onSubmit() {

            const isFormCorrect = await this.v$.$validate();

            if (!isFormCorrect) return;

            this.errors = null

            let data = {
              "passwordConfirm" : this.form.passwordConfirm,
              "password" : this.form.password,
              "userId" : this.$route.params.id,
              "token" : this.$route.params.token
            }

            let config = {
                validateStatus: () => true,
            };
            let vm = this

            axios
                .post(`${this.$store.state.apiUrl}/auth/password/reset`, data, config)
                .then(function (res) {
                    if(res.status != 200) {
                      const errors = res.data.errors || res.data.messages;
                      vm.errors = Array.isArray(errors) ? errors.join(' ') : errors;
                    }else {
                        vm.success = res.data.message;                       
                        vm.password = null;
                        vm.passwordConfirm = null; 
                    }
         
                })     
        },
    },
    mounted() {
      localStorage.removeItem("_safeToken");
    }
    
}
</script>

<style lang="scss" scoped>
  .login-header {
    height:20px;
    width:100%;
    background:$mainColor;
  }

  .login-container {
    min-height: calc(100vh - 20px);
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
    flex-direction: column;
  }

  .login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  form {
    margin-top:80px;
    width:300px;
    margin-left: -20px;
  }

  input {
    text-align: center;
    width:100%;
  }

  ::placeholder {
    text-transform: uppercase;
  }

  .btn {
    width:calc(100% + 23px);
    padding:10px;
    text-transform: uppercase;
  }

  .notices {
    width: 400px;
    margin:20px auto;
  }

h1 {
    color:#fff;
    text-align: center;
    font-size:25px;
    text-transform: uppercase;
    font-weight: 300;
    margin:40px auto 20px auto;
  }

    .main {
    margin: 0;
  }

    .row-btn {
    display:block;
  }

  @media (max-width: 480px) {
    .notices, .notices.errors {
      width:auto;
      max-width:90%;
    }
  }
</style>
